import { PedidosDevedores } from './../../models/dependent.model';
import { Component, OnInit } from '@angular/core';
import { DependentMeepServerModel } from '../../models/dependent.model';
import { Router } from '@angular/router';
import { DependentService } from '../../services/dependent.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { CreditCardModel } from '../../models/creditCard.model';
import { ResponsibleService } from '../../services/responsible.service';
import { PedidosModel } from '../defaulters/defaulters.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent implements OnInit {

  dependents: DependentMeepServerModel[] = new Array<DependentMeepServerModel>();
  dependentsAlreadySearched = false;
  currentDependent = 0;
  creditCards: Array<CreditCardModel> = new Array<CreditCardModel>();
  creditCard: CreditCardModel = new CreditCardModel();
  cvv: string;

  constructor(private router: Router, private dependentService: DependentService, private notificationService: NotificationService) {
  }

  ngOnInit() {
    const reload = localStorage.getItem('reload');
    if (reload) {
      if (new Date().getTime() >= new Date(reload).getTime() + 86400000) {
        localStorage.setItem('reload', new Date().toString());
        location.reload(true);
      }
    } else {
      localStorage.setItem('reload', new Date().toString());
    }
    Promise.all([
      this.dependentService.getDashboardFromMeepServer(),
      this.dependentService.getDashboardFromMeepServerRotativo()
    ])
    .then((response: any) => {
        this.dependents = [];
        this.dependentsAlreadySearched = true;
        response[0].forEach(dependent => {
          dependent.EhNominal = true;
          this.dependents.push(dependent);
        });
        response[1].forEach(dependent => {
          dependent.EhNominal = false;
          this.dependents.push(dependent);
        });
        this.showDefaultersOptions();
    })
    .catch((err) => {
      this.dependentsAlreadySearched = true;
      this.notificationService.showErrorNotification(err.message);
    });
  }

  private showDefaultersOptions() {
    this.dependentService.buscarPedidosEmAberto()
      .then((_pedidos: PedidosModel[]) => {
        if (_pedidos.length > 0) {
          this.notificationService.showQuestionNotification('Você possui saldo devedor. Deseja quitá-lo?')
            .then((response) => {
              if (response.value) {
                this.router.navigate(['/general/defaultersDependents']);
              }
            });
        }
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  goToNutricional(id: string, companyId: string) {
    this.router.navigate([`general/dependentesSingle/${id}/nutricional/${companyId}`]);
  }

  goToAssociar(id: string) {
    this.router.navigate([`general/segundaVia/${id}`]);
  }

  goToExtract(id: string, tipo) {
    this.router.navigate([`general/extrato/${id}/${tipo}`]);
  }

  goToDependents() {
    this.router.navigate(['general/registrarDependente']);
  }

  goToRecharge(id: string, tipo) {
    this.router.navigate([`general/recarga/${id}/${tipo}`]);
  }

  goToSingle(id: string, tipo) {
    this.router.navigate([`general/dependentesSingle/${id}/${tipo}`]);
  }

  changeToPrevDependent() {
    this.currentDependent--;
  }
  changeToNextDependent() {
    this.currentDependent++;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/home/home.component.ts